import React, { ChangeEvent } from "react";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleDot, faDog, faLadderWater, faSquareParking, faWifi } from "@fortawesome/free-solid-svg-icons";
import { AccommodationType } from "@shared/models/article";
import { AnySearchInput } from "../../models/search";
import { featureTranslations } from "../../i18n/sharable-defs";
import SkiAreaSvg from "../../../assets/svg/icone-ski.svg";
import "./search-filter.scss";

type SearchFilterProps = {
  type: AccommodationType;
  data: AnySearchInput;
  onChange?: (value: { type: AccommodationType, criteria: AnySearchInput }) => void;
}

const SearchFilter = (
  {
    type,
    data,
    onChange = () => void 0
  }: SearchFilterProps) => {

  const intl = useIntl();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newData = { ...data };
    delete newData[e.target.id];
    onChange({ type, criteria: { ...newData, ...(e.target.checked) && { [e.target.id]: true } } });
  }

  return (
    <div className="search-filters">

      <label htmlFor="parking" data-gloss={intl.formatMessage(featureTranslations.parking)}>
        <input type="checkbox" id="parking"
               checked={!!data["parking"]}
               onChange={handleChange} />
        <FontAwesomeIcon icon={faSquareParking} />
      </label>

      {[ AccommodationType.RENTAL, AccommodationType.SEASONAL ].includes(type) &&
        <>
          <label htmlFor="wifi" data-gloss={intl.formatMessage(featureTranslations.wifi)}>
            <input type="checkbox" id="wifi"
                   checked={!!data["wifi"]}
                   onChange={handleChange} />
            <FontAwesomeIcon icon={faWifi} />
          </label>
          <label htmlFor="pet" data-gloss={intl.formatMessage(featureTranslations.pet)}>
            <input type="checkbox" id="pet"
                   checked={!!data["pet"]}
                   onChange={handleChange} />
            <FontAwesomeIcon icon={faDog} />
          </label>
        </>
      }

      <label htmlFor="pool" data-gloss={intl.formatMessage(featureTranslations.pool)}>
        <input type="checkbox" id="pool"
               checked={!!data["pool"]}
               onChange={handleChange} />
        <FontAwesomeIcon icon={faLadderWater} />
      </label>

      {[ AccommodationType.RENTAL, AccommodationType.SEASONAL ].includes(type) &&
        <>
          <label htmlFor="cityCenter" data-gloss={intl.formatMessage(featureTranslations.cityCenter)}>
            <input type="checkbox" id="cityCenter"
                   checked={!!data["cityCenter"]}
                   onChange={handleChange} />
            <FontAwesomeIcon icon={faCircleDot} />
          </label>
          <label htmlFor="skiArea" data-gloss={intl.formatMessage(featureTranslations.skiArea)}>
            <input type="checkbox" id="skiArea"
                   checked={!!data["skiArea"]}
                   onChange={handleChange} />
            <SkiAreaSvg />
          </label>
        </>
      }

    </div>);

}

export default SearchFilter
